export class Person {
	anagrafica_id: number;
	codice_fiscale: string;
	nascita_data: Date;
	nascita_comune: string;
	nascita_prov: string;
	societa: boolean;
	in_vita: boolean;
	decesso_data: Date;
	cognome: string;
	nome: string;
	indirizzo: string;
	indirizzo_completo: string;
	civico_num: string;
	cap: string;
	comune: string;
	prov: string;
	email: string;
	telefono: string;
	aggiornamento_utente: number;
	aggiornamento_data: string;
	aggiornamento_data_ridotta: string;
	aggiornamento_data_ridotta_view: string;
	aggiornamento_fonte: string;
	note: string;

	constructor(anagrafica_id = 0){
	    this.anagrafica_id = anagrafica_id;
	    this.clear();
	}

	twoDigits(digit: any) {
	    if(0 <= digit && digit < 10)
		return "0" + digit.toString();
	    if(-10 < digit && digit < 0)
		return "-0" + (-1*digit).toString();
	    return digit.toString();
	}

	clear(){
	    let now = new Date(Date.now());
	    this.codice_fiscale = '';
	    this.nascita_data = null;
	    this.nascita_comune = '';
	    this.nascita_prov = '';
	    this.decesso_data = null;
	    this.in_vita = true;
	    this.cognome = '';
	    this.nome = '';
	    this.societa = false;
	    this.indirizzo = '';
	    this.indirizzo_completo = '';
	    this.civico_num = 'SNC';
	    this.cap = '';
	    this.comune = '';
	    this.prov = '';
	    this.email = '';
	    this.telefono = '';
	    this.aggiornamento_utente = 1;
	    this.aggiornamento_data = now.getUTCFullYear() + "-" + this.twoDigits(1 + now.getUTCMonth()) + "-" + this.twoDigits(now.getUTCDate()) + " " + this.twoDigits(now.getUTCHours()) + ":" + this.twoDigits(now.getUTCMinutes()) + ":" + this.twoDigits(now.getUTCSeconds());
	    this.aggiornamento_data_ridotta = now.getUTCFullYear() + "-" + this.twoDigits(1 + now.getUTCMonth()) + "-" + this.twoDigits(now.getUTCDate());
	    this.aggiornamento_data_ridotta_view = this.twoDigits(now.getUTCDate()) + "/" + this.twoDigits(1 + now.getUTCMonth()) + "/" + now.getUTCFullYear();
	    this.aggiornamento_fonte = "SIATEL";
	    this.note = '';
	}
}

export class AnagraficaDettaglioParameter {
	idPerson: number;
	anagraficaSize: string;
	writePermission: boolean;

	constructor(idPerson: number, anagraficaSize: string, writePermission: boolean){
		this.idPerson = idPerson;
		this.anagraficaSize =  anagraficaSize;
		this.writePermission = writePermission;
	}
  
  getIdPerson(){
    return this.idPerson;
  }
  
  getAnagraficaSize(){
    return this.anagraficaSize;
  }
  
  getWritePermission(){
    return this.writePermission;
  }
  
  setIdPerson(idPerson: number){
    this.idPerson = idPerson;
  }
  
  setAnagraficaSize(anagraficaSize: string){
    this.anagraficaSize = anagraficaSize;
  }
  
  setWritePermission(writePermission: boolean){
    this.writePermission = writePermission;
  }
}